import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import apiUrl from '../constants/ApiUrls';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
  margin: 20px 0;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #007bff;
  margin-bottom: 20px;
`;

const Button = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  color: #fff;
  background-color: #dc3545;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const DeleteAccount: React.FC = () => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    const userId = localStorage.getItem('userId');
    const authToken = localStorage.getItem('authToken');

    if (!userId || !authToken) {
      alert('User not authenticated');
      return;
    }

    try {
      await axios.put(`${apiUrl}/users/${userId}`, {}, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      localStorage.removeItem('authToken');
      localStorage.removeItem('userId');
      alert('Account deleted successfully');
      navigate('/login');
    } catch (error) {
      console.error('Delete account failed:', error);
      alert('Failed to delete account');
    }
  };

  return (
    <Container>
      <Title>Delete Account</Title>
      <Button onClick={handleDelete}>Supprimer mon Compte</Button>
    </Container>
  );
};

export default DeleteAccount;
